/* Cartex Premium — JS léger (sans dépendance) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Apparition au scroll ---------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.cx-reveal:not(.is-visible)');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Header : état "scrollé" ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('cx-scrolled', window.scrollY > 24);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Accordéons : ouverture fluide (fallback) ---------- */
  function initAccordions() {
    if (reduceMotion || (window.CSS && CSS.supports('interpolate-size', 'allow-keywords'))) return;
    document.addEventListener('click', function (event) {
      var summary = event.target.closest('.accordion summary');
      if (!summary) return;
      var details = summary.parentElement;
      var content = details.querySelector('.accordion__content');
      if (!content || !content.animate) return;
      event.preventDefault();
      if (details.open) {
        var anim = content.animate(
          [{ height: content.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 300, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
        content.style.overflow = 'hidden';
        anim.onfinish = function () { details.open = false; content.style.overflow = ''; };
      } else {
        details.open = true;
        var h = content.offsetHeight;
        content.style.overflow = 'hidden';
        content.animate(
          [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }],
          { duration: 380, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        ).onfinish = function () { content.style.overflow = ''; };
      }
    });
  }

  /* ---------- Barre d'achat collante ---------- */
  if (!customElements.get('cx-sticky-atc')) {
    customElements.define('cx-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.target);
        if (!this.target || !('IntersectionObserver' in window)) return;
        this.hidden = false;
        this.querySelector('.cx-sticky__btn').addEventListener('click', () => {
          if (this.target.disabled) {
            this.target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
            return;
          }
          this.target.click();
        });
        this.observer = new IntersectionObserver((entries) => {
          var entry = entries[0];
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', passed);
          document.body.classList.toggle('cx-sticky-on', passed);
        });
        this.observer.observe(this.target);
        this.syncState();
        this.mo = new MutationObserver(() => this.syncState());
        this.mo.observe(this.target, { attributes: true, attributeFilter: ['disabled'] });
      }
      syncState() {
        var btn = this.querySelector('.cx-sticky__btn');
        if (btn) btn.classList.toggle('is-disabled', this.target.hasAttribute('disabled'));
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mo) this.mo.disconnect();
        document.body.classList.remove('cx-sticky-on');
      }
    });
  }

  function init() {
    initReveal();
    initHeaderScroll();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Éditeur de thème : réinitialiser après rechargement d'une section */
  document.addEventListener('shopify:section:load', function (event) { initReveal(event.target); });
})();
